import Vue from 'vue'
import DialogsMountPoint from "@/components/dialogs/DialogsMountPoint";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import Rpc from "@/Rpc";


class DialogManager {
    constructor() {
    }

    getLineInputDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-input");
        return DialogsMountPoint.instance.$refs['inputDialog'];
    }

    getTranslationDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-translation");
        return DialogsMountPoint.instance.$refs['translationDialog'];
    }

    getInterfaceDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-select-interface-dialog-language");
        return DialogsMountPoint.instance.$refs['interfaceLanguageDialog'];
    }

    getTextareaDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-textarea");
        return DialogsMountPoint.instance.$refs['textareaDialog'];
    }

    getHintEditorDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-hint-editor");
        return DialogsMountPoint.instance.$refs['hintEditorDialog'];
    }


    getInfoDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-info");
        return DialogsMountPoint.instance.$refs['infoDialog'];
    }

    getInfoShortDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-short-info");
        return DialogsMountPoint.instance.$refs['infoShortDialog'];
    }

    getErrorDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-error");
        return DialogsMountPoint.instance.$refs['errorDialog'];
    }

    getYesNoDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-yesno");
        return DialogsMountPoint.instance.$refs['yesnoDialog'];
    }

    getBinaryOptionDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-binaryOptionDialog");
        return DialogsMountPoint.instance.$refs['binaryOptionDialog'];
    }

    getInsertNewNameOrganizationDialog(){
        DialogsMountPoint.instance.$bvModal.show("bv-modal-insertNewNameOrganizationDialog");
        return DialogsMountPoint.instance.$refs['insertNewNameOrganizationDialog'];
    }

    getMultiSelectDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-multiselect");
        return DialogsMountPoint.instance.$refs['multiSelectDialog'];
    }

    getImportOrUpdateProductDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-import-or-update-product");
        return DialogsMountPoint.instance.$refs['importOrUpdateProductDialog'];
    }

    getCloseUnsavedDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-close-unsaved");
        return DialogsMountPoint.instance.$refs['closeUnsavedDialog'];
    }

    getCheckboxDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-checkbox");
        return DialogsMountPoint.instance.$refs['checkboxDialog'];
    }

    getDateDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-date");
        return DialogsMountPoint.instance.$refs['dateDialog'];
    }

    getNumericDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-number");
        return DialogsMountPoint.instance.$refs['numericDialog'];
    }

    getPendingDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-pending");
        return DialogsMountPoint.instance.$refs['pendingDialog'];
    }

    getLoggedOffDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-logged-off");
        return DialogsMountPoint.instance.$refs['loggedOffDialog'];
    }

    getCountDownDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-count-down");
        return DialogsMountPoint.instance.$refs['countDownDialog'];
    }

    getChangePasswordDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-change-password");
        return DialogsMountPoint.instance.$refs['changePasswordDialog'];
    }

    getSelectInComboDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-select-combo");
        return DialogsMountPoint.instance.$refs['selectInComboDialog'];
    }

    getMailBrowserDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-mail-browser");
        return DialogsMountPoint.instance.$refs['mailBrowserDialog'];
    }

    getImageDialog(src) {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-image");
        return DialogsMountPoint.instance.$refs['imageDialog'];
    }

    getRegionsDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-region");
        return DialogsMountPoint.instance.$refs['regionsDialog'];
    }

    getAttachmentDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-select-attachment");
        return DialogsMountPoint.instance.$refs['attachmentDialog'];
    }

    getInquiryDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-select-language");
        return DialogsMountPoint.instance.$refs['inquiryDialog'];
    }

    getListOfImagesDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-list-of-images");
        return DialogsMountPoint.instance.$refs['listOfImagesDialog'];
    }

    getShareAttachmentDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-share-attachment");
        return DialogsMountPoint.instance.$refs['shareAttachmentDialog'];
    }

    getDeleteDepartmentDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-delete-department");
        return DialogsMountPoint.instance.$refs['deleteDepartmentDialog'];
    }

    getHelpDialog() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-help");
        return DialogsMountPoint.instance.$refs['helpDialog'];
    }

    getInfoNewOrganization() {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-newOrganization");
        return DialogsMountPoint.instance.$refs['infoNewOrganization']
    }

    report(name) {
        Rpc.Interactions.event("dialog", {name: name}).then();
    }

    /**
     * @param {string} title
     * @param {string} message
     * @param {string=} defaultValue
     * @param {{validationFunction?: function, okVariant?:string, cancelVariant?:string, okTitle:string?, cancelTitle?:string}?} options
     * @return {Promise<string|null>}
     *
     */
    lineInput(title, message, defaultValue, options) {
        this.report("lineInput");
        return new Promise(async (resolve, reject) => {
            let dialog = this.getLineInputDialog();
            dialog.reset(options);
            dialog.title = title;
            dialog.message = message;
            dialog.field.value = defaultValue;
            dialog.field.validationFunction = options?.validationFunction;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} title
     * @param {string} message
     * @param {Boolean=} deleteOption
     * @return {Promise<string|null>}
     *
     */
    textarea(title, message, deleteOption) {
        this.report("textarea");

        return new Promise((resolve, reject) => {
            let dialog = this.getTextareaDialog();
            dialog.reset();
            dialog.title = title;
            dialog.message = message;
            dialog.deleteOption = deleteOption;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} title
     * @param {string} message
     * @param {boolean} editorMode
     * @param {string} formClass
     * @param {string} fieldName
     * @param {boolean} isHintInputMessage
     * @return {Promise<string|null>}
     *
     */
    hintEditor(title, message, editorMode, formClass, fieldName, isHintInputMessage) {
        this.report("hintEditor");

        return new Promise(async (resolve, reject) => {
            let dialog = this.getHintEditorDialog();
            dialog.reset();
            dialog.title = title;
            dialog.defaultAdditionalRestrictions = message;
            dialog.editorMode = editorMode;
            dialog.formClass = formClass;
            dialog.fieldName = fieldName;
            dialog.isHintInputMessage = isHintInputMessage;
            dialog.resolve = resolve;
            await dialog.getHintInput();
        });
    }

    /**
     * @param {string} title
     * @param {string} message
     * @return {Promise<>}
     *
     */
    info(title, message) {
        this.report("info");

        return new Promise((resolve, reject) => {
            let dialog = this.getInfoDialog();
            dialog.reset();
            dialog.title = title;
            dialog.message = message;
            dialog.resolve = resolve;
        });
    }

    infoShort(title, message) {
        this.report("info");

        return new Promise((resolve, reject) => {
            let dialog = this.getInfoShortDialog();
            dialog.reset();
            dialog.title = title;
            dialog.message = message;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} title
     * @param {string} message
     * @return {Promise<>}
     *
     */
    infoNewOrganization(title, message) {
        this.report("InfoNewOrganization");

        return new Promise((resolve, reject) => {
            let dialog = this.getInfoNewOrganization();
            dialog.reset();
            dialog.title = title;
            dialog.message = message;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} title
     * @param {string} message
     * @return {Promise<>}
     *
     */
    infoHtml(title, message) {
        this.report("infoHtml");

        return new Promise((resolve, reject) => {
            let dialog = this.getInfoDialog();
            dialog.reset();
            dialog.title = title;
            dialog.htmlMessage = message;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {String} src
     * @return {Promise<>}
     *
     */
    image(attachment) {
        this.report("image");

        return new Promise(() => {
            let dialog = this.getImageDialog();
            dialog.reset();
            if (_.isString(attachment)) {
                dialog.setAttachment(attachment);
                dialog.setUrl(null);
            } else {
                dialog.setAttachment(attachment);
                dialog.setUrl(attachment.url);
            }

        });
    }

    imagePreview(attachment) {
        this.report("image preview");

        return new Promise(() => {
            let dialog = this.getImageDialog();
            dialog.reset();
            if (_.isString(attachment)) {
                dialog.setAttachment(null);
                dialog.setUrl(attachment);
                dialog.setImagePreview();
            } else {
                dialog.setAttachment(attachment);
                dialog.setUrl(attachment.url);
            }

        });
    }

    errorNotification(exception) {
        this.report("errorNotification");

        return new Promise((resolve, reject) => {
            let dialog = this.getErrorDialog();
            dialog.reset();
            if (exception instanceof RpcInputValidationException) {
                dialog.title = $tr("dialog.write-fail-msg", "Writing your data has failed.");
                if (exception.errorMessage) {
                    dialog.message = exception.errorMessage;
                } else {
                    let invalidFields = {};
                    for (const [key, value] of Object.entries(exception.fields)) {
                        if (!value.isValid) {
                            if (value.errorMessage.includes("$field")) {
                                invalidFields[key] = value.errorMessage.replace("$field", key);
                            } else {
                                invalidFields[key] = value.errorMessage;
                            }
                        }
                    }
                    dialog.message = invalidFields;
                }
            } else {
                dialog.title = "Unknown system error.";
                dialog.message = "Unknown system error.";
            }
            dialog.resolve = resolve;
        });
    }


    /**
     * @param {string} title
     * @param {string} message
     * @param {string=} yesLabel
     * @param {string=} noLabel
     * @return {Promise<>}
     *
     */
    insertNewNameOrganizationDialog(title, message, yesLabel, noLabel) {
        this.report("insertNewNameOrganizationDialog");

        return new Promise((resolve, reject) => {
            let dialog = this.getInsertNewNameOrganizationDialog();
            dialog.yesTitle = yesLabel ? yesLabel : $tr('yes', 'Yes');
            dialog.noTitle = noLabel ? noLabel : $tr('no', 'No');
            dialog.reset();
            dialog.title = title;
            dialog.message = message;
            dialog.resolve = resolve;
        });
    }


    /**
     * @param {string} title
     * @param {string} message
     * @param {string=} createTitle
     * @param {string=} addTitle
     * @return {Promise<Object>}
     */
    binaryOptionDialog(title, message, createTitle = null, addTitle = null) {
        this.report("binaryOptionDialog");

        return new Promise((resolve) => {
            let dialog = this.getBinaryOptionDialog();
            dialog.createTitle = createTitle;
            dialog.addTitle = addTitle;
            dialog.reset();
            dialog.title = title;
            dialog.message = message;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} title
     * @param {string} message
     * @param {Boolean=} isYesDanger
     * @param {string=} yesLabel
     * @param {string=} noLabel
     * @return {Promise<>}
     *
     */
    yesNo(title, message, isYesDanger, yesLabel, noLabel) {
        this.report("yesNo");

        return new Promise((resolve, reject) => {
            let dialog = this.getYesNoDialog();
            dialog.yesTitle = yesLabel ? yesLabel : $tr('yes', 'Yes');
            dialog.noTitle = noLabel ? noLabel : $tr('no', 'No');
            dialog.reset();
            dialog.title = title;
            dialog.message = message;
            dialog.resolve = resolve;
            dialog.isYesDanger = isYesDanger;
        });
    }

    multiSelect(title, availableTags, assignedTags) {
        return new Promise((resolve, reject) => {
            let dialog = this.getMultiSelectDialog();
            dialog.reset();
            dialog.title = title;
            dialog.multiSelectItems = availableTags;
            dialog.multiselectSelected = assignedTags;
            dialog.resolve = resolve;
        });
    }

    /**
     * @return {Promise<>}
     *
     */
    importOrUpdateProduct() {
        this.report("importOrUpdateProduct");

        return new Promise(async (resolve, reject) => {
            let dialog = this.getImportOrUpdateProductDialog();
            await dialog.reset();
            dialog.resolve = resolve;
        });
    }

    /**
     * save|edit|close
     * @param {Boolean} canSave
     * @param {string?} title
     * @param {string?} message
     * @return {Promise<String>}
     *
     */
    closeUnsaved(canSave,
                 title = null,
                 message = null) {

        if (title == null) {
            title = $tr("dialog.unsaved-title", "Unsaved changes");
            message = $tr("dialog.unsaved-msg", "There are unsaved changed in the form. What would you like to do?");
        }
        this.report("closeUnsaved");

        return new Promise((resolve, reject) => {
            let dialog = this.getCloseUnsavedDialog();
            dialog.reset();
            dialog.title = title;
            dialog.canSave = canSave;
            dialog.message = message;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {Boolean} shouldAsk
     * @param {Boolean?} canSave
     * @param {Function?} saveCallback
     * @return {Promise<boolean>}
     */
    async canClose(shouldAsk, canSave, saveCallback) {
        this.report("canClose");

        if (shouldAsk) {
            let action = await this.closeUnsaved(canSave && saveCallback);
            if (action === 'edit') {
                return false;
            }
            if (action === 'close') {
                return true;
            }
            if (action === 'save') {
                setTimeout(() => saveCallback());
                return false;
            }
        }
        return true;
    }


    dialogManagerIsReady() {
        return !!(DialogsMountPoint?.instance?.$bvModal);
    }

    /**
     * @param {string} title
     * @param {string} question
     */
    loggedOff(title, message, countDown) {
        this.report("loggedOff");

        let dialog = this.getLoggedOffDialog();
        dialog.title = title;
        dialog.message = message;
        dialog.startCountDown(countDown);

        return dialog;
    }

    /**
     * @param {string} title
     * @param {string} message
     * @param {string=} okLabel
     * @param {Number=} countDown
     * @param {Number=} enableButtonAfter
     * @return {Promise<>}
     *
     */
    countDown(title, message, okLabel, countDown, enableButtonAfter) {
        okLabel = okLabel || "OK (${countDown})"
        countDown = countDown || 5;
        enableButtonAfter = enableButtonAfter || 0;
        this.report("countDown");

        return new Promise((resolve, reject) => {
            let dialog = this.getCountDownDialog();
            dialog.reset();
            dialog.title = title;
            dialog.message = message;
            dialog.buttonLabel = okLabel;
            dialog.message = message;
            dialog.enableButtonAfer = enableButtonAfter;
            dialog.resolve = resolve;
            dialog.startCountDown(countDown, enableButtonAfter);
        });
    }

    /**
     * @param {string} title
     * @param {string} question
     */
    openPendingDialog(title, message) {
        this.report("pendingDialog");

        if (!DialogsMountPoint.instance) {
            Log.info("Cant open pending dialog");
            return;
        }
        let dialog = this.getPendingDialog();
        dialog.title = title;
        dialog.message = message;
        return dialog;
    }

    closePendingDialog() {
        if (!DialogsMountPoint.instance) {
            Log.info("Cant close pending dialog");
            return;
        }
        DialogsMountPoint.instance.$bvModal.hide("bv-modal-pending");
    }

    /**
     * @param {string} title
     * @param message
     * @param countDown
     */
    changePassword(title, message, countDown) {
        this.report("changePassword");

        let dialog = this.getChangePasswordDialog();
        dialog.title = title;
        dialog.message = message;
        dialog.startCountDown(countDown);
        return dialog;
    }


    /**
     * @param {string} title
     * @param message
     * @param countDown
     */
    replaceOrDelete(title, message, canJustDelete = true) {
        this.report("replaceOrDelete");

        return new Promise((resolve, reject) => {
            DialogsMountPoint.instance.$bvModal.show("bv-modal-save-or-replace");
            let dialog = DialogsMountPoint.instance.$refs['saveOrDeleteDialog'];
            dialog.title = title;
            dialog.message = message;
            dialog.resolve = resolve;
            dialog.canJustDelete = canJustDelete;
        });
    }

    /**
     * @param {string} title
     * @param {{template: string, size: number, name: string, sortable: boolean}} fields
     * @param {[]} lists
     * @param {Function} dataLoad
     * @param {Function} refreshDataLoad
     * @return {Promise<>}
     *
     */
    selectInDataGrid(title, fields, lists, dataLoad = null, refreshDataLoad = null) {
        this.report("selectInDataGrid");

        return new Promise((resolve, reject) => {
            let dialog = this.getSelectInDataGridDialog();
            dialog.reset();
            dialog.title = title;
            dialog.fields = fields;
            dialog.lists = lists;
            dialog.dataLoad = dataLoad ? dataLoad : () => lists;
            dialog.refreshDataLoad = refreshDataLoad ? refreshDataLoad : () => lists;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} title
     * @param {[{value:*, text:string}]} lists
     * @param {Function} dataLoad
     * @param {Function} refreshDataLoad
     * @return {Promise<>}
     *
     */
    selectInCombo(title, lists, dataLoad = null, refreshDataLoad = null) {
        this.report("selectInDataGrid");

        return new Promise((resolve, reject) => {
            let dialog = this.getSelectInComboDialog();
            dialog.reset();
            dialog.title = title;
            dialog.lists = lists;
            dialog.dataLoad = dataLoad ? dataLoad : () => lists;
            dialog.refreshDataLoad = refreshDataLoad ? refreshDataLoad : () => lists;
            dialog.resolve = resolve;
            setTimeout(() => {
                dialog.selectFirst();
            });
        });
    }

    /**
     * @param {string} title
     * @param {string} label
     * @return {Promise<>}
     *
     */
    checkBox(title, label, data) {
        this.report("checkBoxDialog");

        return new Promise((resolve, reject) => {
            let dialog = this.getCheckboxDialog();
            dialog.reset();
            if (data && data.expectedValue) {
                dialog.selected = !dialog.selected;
                if (dialog.selected === false) {
                    dialog.reset();
                }
            }
            dialog.title = title;
            dialog.label = label;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} title
     * @param {Object} filterSpec
     * @return {Promise<>}
     *
     */
    date(title, filterSpec) {
        this.report("dateDialog");
        return new Promise((resolve, reject) => {
            let dialog = this.getDateDialog();
            dialog.reset();
            if (filterSpec) {
                dialog.startDateValue = filterSpec.records.startDateExpectedValue;
                dialog.endDateValue = filterSpec.records.endDateExpectedValue;
            }
            dialog.title = title;
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} title
     * @return {Promise<>}
     *
     */
    numeric(title, data) {
        this.report("numericDialog");
        return new Promise((resolve, reject) => {
            let dialog = this.getNumericDialog();
            if (data?.filterSpec) {
                if (data.filterSpec.min?.value) {
                    dialog.min = data.filterSpec.min.value;
                }
                if (data.filterSpec.max?.value) {
                    dialog.max = data.filterSpec.max.value;
                }
            }
            dialog.reset();
            dialog.title = title;
            dialog.resolve = resolve;
        });
    }


    /**
     * @return {Promise<>}
     *
     */
    mailBrowser() {
        this.report("mailBrowser");

        return new Promise((resolve, reject) => {
            let dialog = this.getMailBrowserDialog();
            dialog.reset();
            dialog.refresh();
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {string} departmentId
     * @return {Promise<>}
     *
     */
    deleteDepartment(departmentId) {
        this.report("deleteDepartment");

        return new Promise(async (resolve, reject) => {
            let dialog = this.getDeleteDepartmentDialog();
            dialog.reset();
            dialog.departmentId = departmentId;
            if (departmentId) {
                await dialog.loadDepartments();
            }
            dialog.resolve = resolve;
        });
    }

    /**
     * @param {Number} numberOfUnsavedAttachments
     * @param {[]} listOfAttachmentsGrid
     * @param {[]} originalList
     * @param {Function} attachmentLoad
     * @return {Promise<>}
     *
     */
    attachmentDialog(numberOfUnsavedAttachments, listOfAttachmentsGrid,
                     originalList, attachmentLoad, editMode = false) {
        this.report("attachmentDialog");

        return new Promise(async (resolve, reject) => {
            let dialog = this.getAttachmentDialog();
            dialog.reset();
            dialog.numberOfUnsavedAttachments = numberOfUnsavedAttachments;
            dialog.listOfAttachmentsGrid = listOfAttachmentsGrid;
            dialog.attachmentLoad = attachmentLoad;
            dialog.originalList = originalList;
            dialog.resolve = resolve;
            if (editMode) {
                dialog.edit();
            }
        });
    }

    /**
     * @param {Boolean} shouldRemember
     * @param {String} language
     * @param {Object} form
     * @param {String} printout
     * @param {Array} selectionLocal
     * @param editMode
     * @param {Boolean} horizontalTemplate
     * @param {Boolean} horizontalTemplateEnabled
     * @return {Promise<>}
     *
     */
    printoutLanguageDialog(shouldRemember, language, form, printout, selectionLocal, editMode = false,
                           horizontalTemplate = "", horizontalTemplateEnabled = true) {
        this.report("inquiryDialog");
        return new Promise(async (resolve, reject) => {
            let dialog = this.getInquiryDialog();
            dialog.reset();
            dialog.prepareListLang();
            dialog.shouldRemember = shouldRemember;
            dialog.language = language;
            dialog.form = form;
            dialog.printout = printout;
            dialog.selectionLocal = selectionLocal;
            dialog.horizontalTemplate = horizontalTemplate;
            dialog.resolve = resolve;
            dialog.horizontalTemplateEnabled = horizontalTemplateEnabled;
            if (editMode) {
                dialog.edit();
            }
        });
    }

    listOfImagesDialog(listOfImagesGrid, originalItem, editMode = false) {
        this.report("listOfImagesDialog");

        return new Promise(async (resolve, reject) => {
            let dialog = this.getListOfImagesDialog();
            dialog.reset()
            dialog.listOfImagesGrid = listOfImagesGrid;
            dialog.originalItem = originalItem;
            dialog.resolve = resolve;
            if (editMode) {
                dialog.edit();
            }
        });
    }

    /**
     * @param {[]} listOfSelectedAttachments
     * @return {Promise<>}

     */
    shareAttachmentDialog(listOfSelectedAttachments) {
        this.report("shareAttachmentDialog");

        return new Promise(async (resolve, reject) => {
            let dialog = this.getShareAttachmentDialog();
            dialog.reset();
            dialog.listOfSelectedAttachments = listOfSelectedAttachments;
            dialog.resolve = resolve;
        });
    }


    /**
     * @param {string} title
     * @param {string} message
     * @return {Promise<>}
     */
    help(title, message) {
        this.report("help");

        return new Promise((resolve, reject) => {
            let dialog = this.getHelpDialog();
            dialog.title = title;
            dialog.message = message;
        });
    }

    getPopupGlass() {
        return DialogsMountPoint.instance.getPopupGlass()
    }

    emptyPopupGlass() {
        DialogsMountPoint.instance.emptyPopupGlass()
    }

    addPopupToGlass(element) {
        DialogsMountPoint.instance.addPopupToGlass(element)
    }

    async selectRegion(currentRegion) {

        return new Promise((resolve, reject) => {
            let dialog = this.getRegionsDialog();
            dialog.reset(currentRegion);
            dialog.resolve = resolve;
        });
    }

    async translate(text, fromLang, toLang) {

        return new Promise((resolve, reject) => {
            let dialog = this.getTranslationDialog();
            dialog.reset({
                input: text,
                fromLang,
                toLang
            });
            dialog.resolve = resolve;
        });
    }

    async selectInterfaceLanguage(selectLang) {
        return new Promise((resolve, reject) => {
            let dialog = this.getInterfaceDialog();
            dialog.reset({
                selectLang
            });
            dialog.resolve = resolve;
        });
    }
}


/** @type {DialogManager} */
DialogManager.instance = new DialogManager();
window["DialogManager"] = DialogManager.instance;
export default DialogManager.instance;
